import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { VisitorLeaveFailedComponent } from './component/visitor-leave-failed.component';



@NgModule({
  declarations: [
    VisitorLeaveFailedComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule
  ]
})
export class VisitorLeaveFailedModule { }
